import React from "react"
import EditableTableHolder from "../components/EditableTableHolder"
import { connect } from "react-redux"
import { authorize } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { salesReportPage } from "../config/routesInfo"
import {
  clear,
  setDateRange,
  filter,
  openPage,
  refresh,
  search,
  sort,
  setSalesReportType,
} from "../ducks/tabularData/salesReport"
import { withTranslation } from "react-i18next"

const columns1 = [
  {
    title: "Штрих код",
    name: "barcode",
    dataType: "string",
    sortable: true,
  },
  {
    title: "title",
    name: "name",
    dataType: "string",
    sortable: true,
  },
  {
    title: "price",
    name: "salePrice",
    dataType: "number",
  },
  {
    title: "quantity",
    name: "quantity",
    dataType: "number",
    sortable: true,
  },
  {
    title: "unitsMeasuring",
    name: "shortName",
    dataType: "string",
  },
  {
    title: "totalPrice",
    name: "total",
    dataType: "number",
    sortable: true,
  },
]

const columns2 = [
  {
    title: "barcode",
    name: "barcode",
    dataType: "string",
    sortable: true,
  },
  {
    title: "title",
    name: "name",
    dataType: "string",
    sortable: true,
  },
  {
    title: "price",
    name: "salePrice",
    dataType: "number",
  },
  {
    title: "quantity",
    name: "quantity",
    dataType: "number",
    sortable: true,
  },
  {
    title: "unitsMeasuring",
    name: "shortName",
    dataType: "string",
  },
  {
    title: "totalPrice",
    name: "total",
    dataType: "number",
    sortable: true,
  },
  {
    title: "stockBalance",
    name: "remainder",
    dataType: "number",
    sortable: true,
  },
  {
    title: "unitsMeasuringStorage",
    name: "stockShortName",
    dataType: "string",
  },
]

@authorize(...salesReportPage.permissions)
@requireStore()
@withTranslation()
@connect(
  (state) => ({
    activeFilters: state.salesReport.filters,
    sortedBy: state.salesReport.sortedBy,
    sortedAsc: state.salesReport.sortedAsc,
    startDate: state.salesReport.startDate,
    endDate: state.salesReport.endDate,
    data: state.salesReport.data,
    isLoading: state.salesReport.pendingRequests > 0,
    pagesCount: state.salesReport.totalPages,
    currentPage: state.salesReport.currentPage,
    totalCount: state.salesReport.totalCount,
    currentStoreId: state.profile.currentStore.id,
    type: state.salesReport.type,
  }),
  (dispatch) => ({
    onSearch: (...data) => dispatch(search(...data)),
    refresh: () => dispatch(refresh()),
    clear: () => dispatch(clear()),
    onPageSelect: (...data) => dispatch(openPage(...data)),
    onSort: (...data) => dispatch(sort(...data)),
    changeFilters: (...data) => dispatch(filter(...data)),
    onSetDateRange: (...data) => dispatch(setDateRange(...data)),
    setType: (type) => dispatch(setSalesReportType(type)),
  }),
)
export default class SalesReportPage extends React.Component {
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentWillUnmount() {
    this.props.clear()
  }

  componentDidMount() {
    this.props.refresh()
    const { onSort } = this.props
    onSort("name")
  }

  render() {
    const {
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      currentPage,
      pagesCount,
      onSearch,
      onPageSelect,
      onSort,
      changeFilters,
      onSetDateRange,
      startDate,
      endDate,
      totalCount,
      t,
      setType,
      type,
    } = this.props
    console.log(type)
    let columns = columns1
    if (type !== "service") {
      columns = columns2
    }
    const tableData = {
      columns,
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      onSort,
      changeFilters,
    }
    return (
      <EditableTableHolder
        title={t("salesReportPage")}
        info={
          <div>
            <p>
              {t(
                "In this section you can observe detailed information about each sold product for a certain period, including",
              )}
            </p>
            <ul>
              <li>{t("barcode")}</li>
              <li>{t("supplyTitle")}</li>
              <li>{t("price").replace(", тг", "")}</li>
              <li>{t("quantity")}</li>
              <li>{t("Unit of measure")}</li>
              <li>{t("Total cost of goods")}</li>
              <li>{t("stockBalance")}</li>
              <li>{t("Unit of measure in stock")}</li>
            </ul>
          </div>
        }
        currentPage={currentPage}
        pagesCount={pagesCount}
        searchInfo="Поиск по штрих-коду или наименованию"
        onPageSelect={onPageSelect}
        onSearch={onSearch}
        startDate={startDate}
        endDate={endDate}
        tableData={tableData}
        isLoading={isLoading}
        onSetDateRange={onSetDateRange}
        noOptions
        totalCount={totalCount || 0}
        salesReport={true}
        setType={setType}
        type={type}
      />
    )
  }
}
